module.exports = __webpack_public_path__ + "img/kantenkontakt.754175a7.svg";